import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import StickerWorkspace from '../ForumMode/StickerWorkspace';
import GuestBanner from './GuestBanner';

/**
 * 訪客貼紙工作區模式 - 極簡 stateless 包裝器
 * 職責：設置 sessionStorage 並渲染對應組件
 */
export default function GuestStickerWorkspace() {
  const { activityId, groupId } = useParams();
  
  // ✅ 在渲染前同步設置 sessionStorage（避免競態條件）
  sessionStorage.setItem('activityId', activityId);
  sessionStorage.setItem('groupId', groupId);
  sessionStorage.setItem('isGuestMode', 'true');
  
  useEffect(() => {
    // 清理函數：離開時清除訪客模式標記
    return () => {
      sessionStorage.removeItem('isGuestMode');
    };
  }, []);
  
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <GuestBanner />
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <StickerWorkspace showNavbar={false} />
      </div>
    </div>
  );
}
